/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { formatEmptyValue } from '@/utils/assets'
import { createId, normalizeValueArrayObjectToString, normalizeValueArrayToString } from '@/utils/general'
import { setPreviewUrl } from '@/utils/items'

const getPendingSamCommonValues = (item) => {
  const { originalAsset, aiMetadataItems } = item
  const creators = formatEmptyValue(
    normalizeValueArrayObjectToString(originalAsset.creators, 'name')
  )
  const publishers = formatEmptyValue(
    normalizeValueArrayObjectToString(originalAsset.publishers, 'name')
  )
  const fileType = formatEmptyValue(
    normalizeValueArrayToString(originalAsset.fileType)
  )
  const title = originalAsset.title
  const aiMetadataNames = aiMetadataItems?.map(item => {
    return item.embeddingModel?.name
  })

  return {
    aiMetadata: {
      items: aiMetadataNames,
      total: aiMetadataNames.length
    },
    aiMetadataIds: aiMetadataItems.map(item => item.id),
    creators,
    fileType,
    licensedAssetId: item.licensedAssetId,
    publishers,
    sharedAt: item.sharedAt,
    title
  }
}

export const getPendingSamCardProps = (item) => {
  const {
    aiMetadata,
    aiMetadataIds,
    assetId,
    creators,
    fileType,
    licensedAssetId,
    publishers,
    sharedAt,
    title
  } = getPendingSamCommonValues(item)
  const { originalAsset } = item

  return {
    aiMetadata,
    aiMetadataIds,
    assetId,
    creators,
    fileType,
    imageUrl: setPreviewUrl(originalAsset.coverUrl, fileType),
    key: createId(),
    licensedAssetId,
    publishers,
    sharedAt,
    title
  }
}

export const getPendingSamTableProps = (item) => {
  const {
    aiMetadata,
    aiMetadataIds,
    assetId,
    creators,
    fileType,
    licensedAssetId,
    publishers,
    sharedAt,
    title
  } = getPendingSamCommonValues(item)
  return {
    aiMetadata,
    aiMetadataIds,
    aiMetadataShared: aiMetadata?.items,
    assetId,
    creators,
    fileType,
    id: licensedAssetId,
    key: createId(),
    licensedAssetId,
    publishers,
    sharedAt,
    title,
    totalAiMetadata: aiMetadata?.total
  }
}

export const pendingSamsListColumns = [
  {
    accessorKey: 'licensedAssetId',
    enableHiding: false,
    header: 'Licensed AssetId Id'
  },
  {
    accessorKey: 'title',
    enableHiding: false,
    header: 'Title'
  },
  {
    accessorKey: 'sharedAt',
    enableHiding: false,
    header: 'Shared At'
  },
  {
    accessorKey: 'creators',
    header: 'Creators'
  },
  {
    accessorKey: 'publishers',
    header: 'Publishers'
  },
  {
    accessorKey: 'fileType',
    header: 'File Type'
  },
  {
    accessorKey: 'aiMetadataShared',
    header: 'AI Metadata Shared',
    enableHiding: false
  },
  {
    accessorKey: 'actions',
    enableHiding: false,
    header: ''
  }
]

const defaultHiddenColumns = [
  'creators',
  'publishers',
  'fileType'
]
export const tableInitialState = {
  columnVisibility: Object.fromEntries(
    defaultHiddenColumns.map((id) => [id, false])
  )
}
